module.exports = __webpack_public_path__ + "static/img/coupon-nodata.9baa52c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/new-user/coupon-nodata.png
// module id = QzVz
// module chunks = 4